import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "How to make the perfect iPad stand out of LEGO's",
  "description": "",
  "published": "2012-06-19T00:00:00.000Z",
  "redirect_from": ["/blog/how-to-make-the-perfect-ipad-stand-out-of-legos/swizec/4676"],
  "categories": "IPad, IPhone, Lego, Toys, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://distilleryimage3.instagram.com/773be45aba2511e18cf91231380fd29b_7.jpg",
        "alt": "My LEGO iPad stand",
        "title": "My LEGO iPad stand"
      }}></img></p>
    <p>{`Today I finally got fed up with the `}<em parentName="p">{`"Make my `}<a parentName="em" {...{
          "href": "http://www.apple.com/ipad/",
          "title": "iPad"
        }}>{`iPad`}</a>{` stand up"`}</em>{` dance. You know the one:`}</p>
    <p><em parentName="p">{`Leeeaaan the iPad ever so carefully against a stack of books. Slides. Falls. No good.`}</em></p>
    <p><em parentName="p">{`Ok, maybe if I put some rubber bands under so it won't slip ...`}</em></p>
    <p><em parentName="p">{`Nope.`}</em></p>
    <p><em parentName="p">{`Maybe if I wedge it juuuuust right between the notebook and the books ...`}</em></p>
    <p>{`After two years of dancing this dance - and being too cheap to buy a proper stand - I finally realized some of my `}<a parentName="p" {...{
        "href": "http://www.lego.com/",
        "title": "Lego"
      }}>{`LEGO`}</a>{`'s possess the perfect angles to prop it up just right.`}</p>
    <h2 {...{
      "id": "the-lego-ipad-stand"
    }}>{`The LEGO iPad stand`}</h2>
    <p>{`After ~40 minutes of tinkering I had a stand. A simple, dare I say elegant?, stand. Only 30 pieces. Even the colours match so it's definitely the most beautiful LEGO creation I have ever made!`}</p>
    <p>{`The angle did in fact turn out perfect. The whole thing is even sturdy enough to withstand wild tapping and swiping conditions. For bonus points, an iPhone also fits (I didn't plan this one).`}</p>
    <p>{`Here's how you can make one yourself:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step0-1024x764.jpg",
        "alt": "Step 0: Get some LEGO's",
        "title": "Step 0: Get some LEGO's"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step1-1024x764.jpg",
        "alt": "Step1: put some spacers together",
        "title": "Step1: put some spacers together"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step2-1024x764.jpg",
        "alt": "Step2: Spacers go in the big yellow bit",
        "title": "Step2: Spacers go in the big yellow bit"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step3-1024x764.jpg",
        "alt": "Step3: Start assembling the legs",
        "title": "Step3: Start assembling the legs"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step4-1024x764.jpg",
        "alt": "Step4: this is where the iPad rests",
        "title": "Step4: this is where the iPad rests"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step5-1024x764.jpg",
        "alt": "Step5: finish assembling the main body",
        "title": "Step5: finish assembling the main body"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step6-1024x764.jpg",
        "alt": "Step6: attach the main leg",
        "title": "Step6: attach the main leg"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step7-1024x764.jpg",
        "alt": "Step7: two more placeholders",
        "title": "Step7: two more placeholders"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-step8-1024x764.jpg",
        "alt": "Step8: add the main weight supports",
        "title": "Step8: add the main weight supports"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/06/lego-ipad-stand-done-1024x764.jpg",
        "alt": "Enjoy your new iPad stand",
        "title": "Enjoy your new iPad stand"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.geardiary.com/2012/06/18/spigen-sgp-ultra-thin-case-for-the-new-ipad-review/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95108048_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.geardiary.com/2012/06/18/spigen-sgp-ultra-thin-case-for-the-new-ipad-review/"
        }}>{`SPIGEN SGP Ultra Thin Case for the New iPad, Review`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://techie-buzz.com/innovations/legos-iphones.html"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/95012276_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://techie-buzz.com/innovations/legos-iphones.html"
        }}>{`LEGOs and iPhones in Infinite Combinations`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.loop11.com/testing-on-ipad/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_07_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.loop11.com/testing-on-ipad/"
        }}>{`Usability Testing On The iPad | Loop11`}</a></li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/2012/6/prweb9580848.htm"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_20_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/2012/6/prweb9580848.htm"
        }}>{`New iPad Accessories from SMARTdesks - armPad iPad arm and iDrawer iPad Security Compartment`}</a></li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=8bb28ada-4ac1-414e-baba-677051861028",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      